export const getPrivateGroupSize = (
  bookingDetails: Detail[],
  availabilityType?: string
) => {
  return bookingDetails
    .filter(
      (detail) =>
        availabilityType === "PRIVATE" ||
        detail.productPrice?.excludeFromPrivateGroupCount === false ||
        detail.excludeFromPrivateGroupCount === false
    )
    .reduce((sum, detail) => sum + detail.quantity, 0);
};

type Detail = {
  quantity: number;
  excludeFromPrivateGroupCount?: boolean;
  productPrice?: {
    excludeFromPrivateGroupCount?: boolean;
  };
};
